import { Button, TextField } from '@mui/material';
import { Link } from 'react-router-dom';
import { BaseSyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import logoVidelio from '../../assets/images/videlio_logo_filed_color.svg';

function PasswordRecovery() {
  const { t } = useTranslation();

  const initError = {
    emailError: false,
    emailHelper: '',
  };

  const [isError, setIsError] = useState(initError);

  const [email, setEmail] = useState('');

  const handleChange = (event: BaseSyntheticEvent) => {
    setEmail(event.target.value);
  };

  const validateEmail = (emailToValidate: string) => emailToValidate.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  );

  const onPasswordRecovery = (event: BaseSyntheticEvent) => {
    event.preventDefault();
    const tempError = { ...initError };
    if (email === '') {
      tempError.emailError = true;
      tempError.emailHelper = 'PasswordRecovery.emailRequired';
    }
    if (!validateEmail(email)) {
      tempError.emailError = true;
      tempError.emailHelper = 'PasswordRecovery.wrongFormat';
    }
    setIsError(tempError);
  };

  return (
    <div className="login">
      <img className="logo" src={logoVidelio} alt="logo videlio" />
      <div className="grid-item-1" />
      <div className="grid-item-2">
        <form onSubmit={onPasswordRecovery} className="form">
          <h1>{t('PasswordRecovery.title')}</h1>
          <TextField
            variant="outlined"
            label={t('PasswordRecovery.email')}
            value={email}
            onChange={handleChange}
            error={isError.emailError}
            helperText={isError.emailError ? t(isError.emailHelper) : ''}
            type="email"
            name="email"
            placeholder="Ex. pat@example.com"
            required
          />
          <Button type="submit" value="submit" variant="contained">{t('PasswordRecovery.submit')}</Button>
        </form>
        <div className="bottom">
          <Button component={Link} to="/login">{t('PasswordRecovery.connection')}</Button>
        </div>
      </div>
    </div>
  );
}

export default PasswordRecovery;
